import React, { useEffect, useState } from 'react';
import Footer from '../components/Footer';

const TuitionFeeChart = () => {
  const [feeData, setPrograms] = useState([]);

  const fetchPrograms = async () => {
    try {
      const res = await fetch('/feechart.json');
      if (!res.ok) throw new Error('Could not load program data');
      const data = await res.json();
      let row = []; 
      for(let i=0;i<data.length;i++){
        row.push(data[i]);
        
        setTimeout(()=>{
            setPrograms(row);
        }, 500)
        
      }
      
    } catch (error) {
      console.error(error.message);
    }
  };

  useEffect(() => {
    fetchPrograms();
  }, []);

  return (
    <div>
      <div style={containerStyle}>
        <h2 style={headingStyle}>📊 Fee Chart</h2>
        <div style={tableWrapper}>
          <table style={tableStyle}>
            <thead>
              <tr>
                <th style={thStyle}>Subjects</th>
                <th style={thStyle}>3 Days</th>
                <th style={thStyle}>5 Days</th>
                <th style={thStyle}>Weekends</th>
              </tr>
            </thead>
            <tbody>
              {feeData.map((row, index) => (
                <tr
                  key={index}
                  style={{
                    ...tdRowStyle,
                    animationDelay: `${index * 0.1}s`,
                  }}
                >
                  <td style={tdStyle}>{row.subject}</td>
                  <td style={tdStyle1}>{row.day3}</td>
                  <td style={tdStyle}>{row.day5}</td>
                  <td style={tdStyle1}>{row.weekends}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <Footer />
    </div>
  );
};

const containerStyle = {
  padding: '40px 20px',
  fontFamily: 'Segoe UI, sans-serif',
  backgroundColor: '#fafafa',
};

const headingStyle = {
  textAlign: 'center',
  marginBottom: '20px',
  fontSize: '2rem',
  color: '#333',
};

const tableWrapper = {
  overflowX: 'auto',
  maxWidth: '900px',
  margin: '0 auto',
  borderRadius: '12px',
  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
};

const tableStyle = {
  borderCollapse: 'collapse',
  width: '100%',
  minWidth: '600px',
  backgroundColor: '#fff',
};

const thStyle = {
  border: '1px solid #e0e0e0',
  padding: '16px',
  textAlign: 'center',
  backgroundColor:"var(--primary)",
  color: '#fff',
  fontWeight: '600',
  textTransform: 'uppercase',
};

const tdStyle = {
  border: '1px solid var(--primary)',
  backgroundColor : "#e0e0e0",
  padding: '14px',
  textAlign: 'center',
  fontSize: '1rem',
  color: '#333',
};

const tdStyle1 = {
  border: '1px solid var(--primary)',
  backgroundColor : "var(--secondary)",
  padding: '14px',
  textAlign: 'center',
  fontSize: '1rem',
  color: '#333',
};

const tdRowStyle = {
  backgroundColor: '#f9f9f9',
  transition: 'background-color 0.3s ease',
  animation: 'fadeIn 0.1s ease forwards',
};

const styleSheet = document.styleSheets[0];
styleSheet.insertRule(`
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}
`, styleSheet.cssRules.length);

export default TuitionFeeChart;
